import React, { FC, MouseEventHandler, ReactElement } from 'react';
import styled from 'styled-components';
import * as tokens from '@utmost.co/utmost-design-tokens';
import OcPopover, { PopoverOrigin } from '../Popover/OcPopover';
import useOcPopover from '../Popover/useOcPopover';
import Tooltip from '../Tooltip/Tooltip';
import { Uds } from '../../types';

export type DropdownProps = Uds<{
  tooltip?: string;
  children: any;
  ButtonItem(disabled?: boolean, active?: boolean, fullWidth?: boolean): ReactElement;
  closeOnSelect?: boolean;
  onClose?(): void;
  onOpen?(): void;
  disabled?: boolean;
  fullWidth?: boolean;
  active?: boolean;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}>;

const nope = () => ({});

export const Dropdown: FC<React.PropsWithChildren<DropdownProps>> = ({
  tooltip = '',
  dataTest,
  disabled,
  active,
  fullWidth,
  closeOnSelect = true,
  ButtonItem,
  onClose,
  onOpen,
  anchorOrigin,
  transformOrigin,
  children
}) => {
  const popover = useOcPopover(onClose, onOpen);
  return (
    <>
      <Tooltip title={tooltip} disabled={disabled || !tooltip}>
        <StyledActiveWrapper $active={active} $fullWidth={fullWidth}>
          <span data-test={dataTest} onClick={!disabled ? popover.toggle : nope}>
            {ButtonItem(disabled, active, fullWidth)}
          </span>
        </StyledActiveWrapper>
      </Tooltip>
      <OcPopover
        open={popover.open}
        anchorEl={popover.anchorEl}
        onClose={popover.close}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <div onClick={closeOnSelect ? (popover.close as MouseEventHandler<HTMLDivElement>) : nope}>{children}</div>
      </OcPopover>
    </>
  );
};

export default Dropdown;

const StyledActiveWrapper = styled.span<{ $active?: boolean; $fullWidth?: boolean }>`
  && {
    display: inline-block;
    vertical-align: middle;
    ${({ $fullWidth }) => ($fullWidth ? 'width: 100%;' : '')}

    path {
      fill: ${({ $active }) => ($active ? tokens.colorPrimary : undefined)} !important;
    }
  }
`;

StyledActiveWrapper.displayName = 'DropdownWrapper';
